<template>
  <div id="kt_content" class="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
    <!-- begin:: Content Head -->
    <div id="kt_subheader" class="kt-subheader kt-grid__item">
      <div class="kt-container  kt-container--fluid ">
        <div class="kt-subheader__main">
          <h2 class="kt-subheader__title">
            Projects
          </h2>
          <span class="kt-subheader__separator kt-subheader__separator--v" />
          <div id="kt_subheader_search" class="kt-subheader__group">
            <span v-if="isLoadProject" id="kt_subheader_total" class="kt-subheader__desc">
              {{ allProject.projects.length }} total
            </span>
            <span v-else id="kt_subheader_total" class="kt-subheader__desc">
              {{ 0 }} total
            </span>
            <!--            <span v-else id="kt_subheader_total" class="kt-subheader__desc">-->
            <!--              {{ '0' || allProject.projects.length }} total <div class="kt-spinner kt-spinner&#45;&#45;sm kt-spinner&#45;&#45;brand kt-ml-10"></div>-->
            <!--            </span>-->
          </div>
        </div>
        <div class="kt-subheader__toolbar">
          <!-- Button trigger modal -->
          <button
            type="button"
            class="btn btn-brand"
            data-toggle="modal"
            data-target="#addProjectModal"
            @click="trackCustomEvent({ action: 'clicked', target: 'create_project_content' }); showModal()"
          >
            <i class="flaticon2-plus" /> Create Project
          </button>
        </div>
      </div>
    </div>

    <!-- create project modal -->
    <div id="addProjectModal" ref="create-new-project-modal" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="addProjectLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 id="addProjectLabel" class="modal-title">
              New project
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span>×</span>
            </button>
          </div>
          <div class="modal-body">
            <b-form-group :state="newProjectDetail.name.length >= 4 && isNameInputChanged" label="Project name:" label-for="project-name-input" :invalid-feedback="invalidFeedback">
              <b-form-input
                id="project-name-input"
                v-model="newProjectDetail.name"
                @input="trackCustomEvent({ event: 'input', action: 'type', target: 'modal_input_box_content', value: newProjectDetail.name })"
              />
            </b-form-group>

            <b-form-group label="Project description:" label-for="project-description-input">
              <b-form-textarea
                id="project-description-input"
                v-model="newProjectDetail.description"
                rows="3"
                @input="trackCustomEvent({ event: 'input', action: 'type', target: 'modal_textarea_content', value: newProjectDetail.description })"
              />
            </b-form-group>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="trackCustomEvent({ action: 'clicked', target: 'modal_cancel_content' }); hideModal()"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-brand"
              :class="{ 'kt-spinner kt-spinner--sm kt-spinner--light': isWaitResponse }"
              :disabled="!validInput"
              @click="trackCustomEvent({ action: 'clicked', target: 'modal_create_project_content' }); addProject()"
            >
              Create Project
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- end:: Content Head -->

    <!-- begin:: Content -->
    <div class="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
      <!--Begin::Section-->
      <LoadingSpinner v-if="!isLoadProject" />
      <div v-else-if="allProject.projects.length > 0" class="row">
        <div v-for="project in allProject.projects" :key="project.id" class="col-xl-4 project-card">
          <!--begin:: Portlet-->
          <div
            class="kt-portlet kt-portlet--height-fluid"
            @click="trackCustomEvent({ action: 'clicked', target: 'lists_content', linkTo: 'dashboard' })"
          >
            <router-link :to="`dashboard/${project.id}`" class="kt-widget__title flex-grow-1">
              <div class="kt-portlet__body kt-portlet__body--fit">
                <!--begin::Widget -->
                <div class="kt-widget kt-widget--project-1">
                  <div class="kt-widget__head d-flex">
                    <div class="kt-widget__label">
                      <div class="kt-widget__info kt-padding-0">
                        <div class="kt-widget__title">
                          {{ project.name }}
                        </div>
                        <span class="kt-widget__desc kt-label-font-color-1">
                          ID: {{ project.id.substr(0,10) }}
                        </span>
                        <div class="kt-label-font-color-2 kt-margin-t-5">
                          <span class="kt-margin-r-30"><i class="flaticon2-gear" /> {{ project.serviceCount }} Services </span>
                          <span><i class="flaticon2-lock" /> {{ project.tokenCount }} Tokens </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="kt-widget__body">
                    <span class="kt-widget__section kt-margin-t-0 kt-padding-t-5 kt-label-font-color-1">
                      {{ project.description }}
                    </span>
                    <div v-if="isWarning" class="kt-section__content kt-margin-t-30">
                      <div class="alert alert-solid-warning alert-bold" role="alert">
                        <div class="alert-text">
                          <i class="flaticon2-warning kt-margin-r-5" />
                          A simple warning alert <a href="#" class="kt-link">check it out!</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              <!--end::Widget -->
              </div>
            </router-link>
          </div>

          <!--end:: Portlet-->
        </div>
      </div>
      <div v-else class="d-flex flex-column justify-content-center align-items-center kt-label-font-color-1 kt-mt-100" style="height:200px;">
        <FileIcon />
        <h5><span>No Project Available</span></h5>
        <p>Please create new project.</p>
      </div>

      <!--End::Section-->
    </div>
    <!-- end:: Content -->
  </div>
</template>

<script>
import { BFormGroup, BFormInput, BFormTextarea } from 'bootstrap-vue'
import { mapGetters, mapActions } from 'vuex'
import Swal from 'sweetalert2'
import LoadingSpinner from '../components/LoadingSpinner'
import FileIcon from '../components/FileIcon'

export default {
  components: {
    'b-form-group': BFormGroup,
    'b-form-input': BFormInput,
    'b-form-textarea': BFormTextarea,
    LoadingSpinner,
    FileIcon
  },
  data () {
    const billDateOptions = []

    for (let i = 1; i <= 31; i++) {
      billDateOptions.push({ value: i, text: `${i}` })
    }

    return {
      // state: null,
      isNameInputChanged: false,
      newProjectDetail: {
        name: '',
        description: '',
        billDate: ''
      },
      billDateOptions,
      isWarning: false,
      isWaitResponse: false,
      isCreateNewProject: false,
      isLoadProject: false
    }
  },
  computed: {
    invalidFeedback () {
      if (!this.isNameInputChanged || this.newProjectDetail.name.length >= 4) {
        return ''
      } else if (this.newProjectDetail.name.length > 0) {
        return 'Project name must be at least 4 characters'
      } else {
        return 'Project name is required'
      }
    },
    validInput () {
      // return !!(this.newProjectDetail.name.length >= 4 && this.newProjectDetail.billDate)
      return !!(this.newProjectDetail.name.length >= 4)
    },
    userId () {
      return this.getUserDetail ? this.getUserDetail.userId : ''
    },
    ...mapGetters({
      getUserDetail: 'user/getUserDetail',
      allProject: 'project/getAllProject'
    })
  },
  watch: {
    'newProjectDetail.name': function () {
      this.isNameInputChanged = true
    }
  },
  async mounted () {
    await this.loadAllProject()
    this.isLoadProject = true
  },
  methods: {
    ...mapActions({
      loadAllProject: 'project/loadAllProject',
      addNewProject: 'project/addProject',
      deleteProjectRequest: 'project/deleteProject',
      trackCustomEvent: 'user/trackCustomEvent'
    }),
    async addProject () {
      this.isWaitResponse = true
      //  TODO Delete this line when we re-enable bill system
      this.newProjectDetail.billDate = 1
      const response = await this.addNewProject({
        userId: this.userId,
        newProjectDetail: this.newProjectDetail
      })
      await this.loadAllProject()
      //  TODO Can we do this thing in another way ?
      $('#addProjectModal').modal('hide')
      if (response) {
        Swal.fire({
          title: 'Done !',
          text: 'Your project has been created',
          type: 'success',
          heightAuto: false
        })
      } else {
        Swal.fire({
          title: 'Error !',
          text: 'Something went wrong. Please try again',
          type: 'error',
          heightAuto: false
        })
      }
      this.isWaitResponse = false
      this.isNameInputChanged = false
    },
    deleteProject (projectId) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        heightAuto: false,
        showCancelButton: true,
        cancelButtonText: 'No',
        confirmButtonText: 'Yes',
        showCloseButton: true,
        reverseButtons: true
      }).then(async (result) => {
        if (result.value) {
          // TODO Test this again
          await this.deleteProjectRequest({
            userId: this.userId,
            projectId: this.projectId
          })
          Swal.fire({
            title: 'Deleted',
            text: '',
            type: 'success',
            heightAuto: false
          })
          this.loadAllProject()
        }
      })
    },
    showModal () {
      this.newProjectDetail.name = ''
      this.newProjectDetail.description = ''
      this.newProjectDetail.billDate = ''
      this.isNameInputChanged = false
    },
    hideModal () {
      this.isNameInputChanged = false
    }
  }
}
</script>

<style scoped>
  /* .kt-widget.kt-widget--user-p rofile-2 .kt-widget__body .kt-widget__section {
    padding: 1rem;
  } */
  .kt-subheader--enabled.kt-subheader--transparent:not(.kt-subheader--fixed) .kt-content {
    padding-top: 0;
  }
  .kt-spinner-custom-margin {
    max-width: 20px;
    margin: 2em auto;
  }
  /* .project-card {
    max-width: 280px;
  } */
  .project-card-header {
    display: flex;
    width: 100%;
  }
  .project-name {
    flex-grow: 1;
  }
  .flex-grow-1 {
    flex-grow: 1;
  }
</style>
